module.exports = __webpack_public_path__ + "static/media/locationNew.f2609c17.svg";